import React from 'react';
import Button from '@material-ui/core/Button';
import styled from "styled-components"
import TouchAppIcon from '@material-ui/icons/TouchApp';


export const CtaButton = styled(Button).attrs({
  component:"a",
  color:"primary",
  startIcon:<TouchAppIcon />,
})`
  font-weight:700;
  font-size: 1.2rem;
  > * {
    pointer-events:none;
  }
`;